// source: witbooking/backoffice/tags/v1/tag_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.AppliesTo', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.AppliesToType', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.GetTagsRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.GetTagsResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.Tag', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.TickerWithPosition', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.Translation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.GetTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.GetTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.GetTagsRequest.displayName = 'proto.witbooking.backoffice.tag.v1.GetTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.tag.v1.GetTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.GetTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.GetTagsResponse.displayName = 'proto.witbooking.backoffice.tag.v1.GetTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.displayName = 'proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.displayName = 'proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.displayName = 'proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.Tag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.tag.v1.Tag.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.Tag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.Tag.displayName = 'proto.witbooking.backoffice.tag.v1.Tag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.Translation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.Translation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.Translation.displayName = 'proto.witbooking.backoffice.tag.v1.Translation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.AppliesTo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.tag.v1.AppliesTo.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.AppliesTo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.AppliesTo.displayName = 'proto.witbooking.backoffice.tag.v1.AppliesTo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.tag.v1.TickerWithPosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.tag.v1.TickerWithPosition.displayName = 'proto.witbooking.backoffice.tag.v1.TickerWithPosition';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.GetTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.GetTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.GetTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.GetTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.GetTagsRequest}
 */
proto.witbooking.backoffice.tag.v1.GetTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.GetTagsRequest;
  return proto.witbooking.backoffice.tag.v1.GetTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.GetTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.GetTagsRequest}
 */
proto.witbooking.backoffice.tag.v1.GetTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.GetTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.GetTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.GetTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.GetTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.GetTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.GetTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsList: jspb.Message.toObjectList(msg.getTagsList(),
    proto.witbooking.backoffice.tag.v1.Tag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.GetTagsResponse}
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.GetTagsResponse;
  return proto.witbooking.backoffice.tag.v1.GetTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.GetTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.GetTagsResponse}
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.tag.v1.Tag;
      reader.readMessage(value,proto.witbooking.backoffice.tag.v1.Tag.deserializeBinaryFromReader);
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.GetTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.GetTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.tag.v1.Tag.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Tag tags = 1;
 * @return {!Array<!proto.witbooking.backoffice.tag.v1.Tag>}
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.prototype.getTagsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.tag.v1.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.tag.v1.Tag, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.tag.v1.Tag>} value
 * @return {!proto.witbooking.backoffice.tag.v1.GetTagsResponse} returns this
*/
proto.witbooking.backoffice.tag.v1.GetTagsResponse.prototype.setTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.tag.v1.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.tag.v1.Tag}
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.prototype.addTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.tag.v1.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.tag.v1.GetTagsResponse} returns this
 */
proto.witbooking.backoffice.tag.v1.GetTagsResponse.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagsappliestoList: jspb.Message.toObjectList(msg.getTagsappliestoList(),
    proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest;
  return proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo;
      reader.readMessage(value,proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.deserializeBinaryFromReader);
      msg.addTagsappliesto(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsappliestoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UpdateTagAppliesTo tagsAppliesTo = 1;
 * @return {!Array<!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo>}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.prototype.getTagsappliestoList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo>} value
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} returns this
*/
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.prototype.setTagsappliestoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.prototype.addTagsappliesto = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest} returns this
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToRequest.prototype.clearTagsappliestoList = function() {
  return this.setTagsappliestoList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse;
  return proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.UpdateTagsAppliesToResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.toObject = function(includeInstance, msg) {
  var f, obj = {
    tagid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updatesappliesto: (f = msg.getUpdatesappliesto()) && proto.witbooking.backoffice.tag.v1.AppliesTo.toObject(includeInstance, f),
    deletionsappliesto: (f = msg.getDeletionsappliesto()) && proto.witbooking.backoffice.tag.v1.AppliesTo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo;
  return proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagid(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.tag.v1.AppliesTo;
      reader.readMessage(value,proto.witbooking.backoffice.tag.v1.AppliesTo.deserializeBinaryFromReader);
      msg.setUpdatesappliesto(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.tag.v1.AppliesTo;
      reader.readMessage(value,proto.witbooking.backoffice.tag.v1.AppliesTo.deserializeBinaryFromReader);
      msg.setDeletionsappliesto(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdatesappliesto();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.witbooking.backoffice.tag.v1.AppliesTo.serializeBinaryToWriter
    );
  }
  f = message.getDeletionsappliesto();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.witbooking.backoffice.tag.v1.AppliesTo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tagId = 1;
 * @return {string}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.getTagid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo} returns this
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.setTagid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AppliesTo updatesAppliesTo = 2;
 * @return {?proto.witbooking.backoffice.tag.v1.AppliesTo}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.getUpdatesappliesto = function() {
  return /** @type{?proto.witbooking.backoffice.tag.v1.AppliesTo} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.tag.v1.AppliesTo, 2));
};


/**
 * @param {?proto.witbooking.backoffice.tag.v1.AppliesTo|undefined} value
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo} returns this
*/
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.setUpdatesappliesto = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo} returns this
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.clearUpdatesappliesto = function() {
  return this.setUpdatesappliesto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.hasUpdatesappliesto = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AppliesTo deletionsAppliesTo = 3;
 * @return {?proto.witbooking.backoffice.tag.v1.AppliesTo}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.getDeletionsappliesto = function() {
  return /** @type{?proto.witbooking.backoffice.tag.v1.AppliesTo} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.tag.v1.AppliesTo, 3));
};


/**
 * @param {?proto.witbooking.backoffice.tag.v1.AppliesTo|undefined} value
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo} returns this
*/
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.setDeletionsappliesto = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo} returns this
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.clearDeletionsappliesto = function() {
  return this.setDeletionsappliesto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.tag.v1.UpdateTagAppliesTo.prototype.hasDeletionsappliesto = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.tag.v1.Tag.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.Tag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.Tag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.Tag.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticker: jspb.Message.getFieldWithDefault(msg, 2, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.tag.v1.Translation.toObject, includeInstance),
    appliestoList: jspb.Message.toObjectList(msg.getAppliestoList(),
    proto.witbooking.backoffice.tag.v1.AppliesTo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.Tag}
 */
proto.witbooking.backoffice.tag.v1.Tag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.Tag;
  return proto.witbooking.backoffice.tag.v1.Tag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.Tag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.Tag}
 */
proto.witbooking.backoffice.tag.v1.Tag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.tag.v1.Translation;
      reader.readMessage(value,proto.witbooking.backoffice.tag.v1.Translation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.tag.v1.AppliesTo;
      reader.readMessage(value,proto.witbooking.backoffice.tag.v1.AppliesTo.deserializeBinaryFromReader);
      msg.addAppliesto(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.Tag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.Tag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.Tag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.tag.v1.Translation.serializeBinaryToWriter
    );
  }
  f = message.getAppliestoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.witbooking.backoffice.tag.v1.AppliesTo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.tag.v1.Tag} returns this
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticker = 2;
 * @return {string}
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.tag.v1.Tag} returns this
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Translation translations = 3;
 * @return {!Array<!proto.witbooking.backoffice.tag.v1.Translation>}
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.tag.v1.Translation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.tag.v1.Translation, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.tag.v1.Translation>} value
 * @return {!proto.witbooking.backoffice.tag.v1.Tag} returns this
*/
proto.witbooking.backoffice.tag.v1.Tag.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.tag.v1.Translation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.tag.v1.Translation}
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.tag.v1.Translation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.tag.v1.Tag} returns this
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * repeated AppliesTo appliesTo = 4;
 * @return {!Array<!proto.witbooking.backoffice.tag.v1.AppliesTo>}
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.getAppliestoList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.tag.v1.AppliesTo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.tag.v1.AppliesTo, 4));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.tag.v1.AppliesTo>} value
 * @return {!proto.witbooking.backoffice.tag.v1.Tag} returns this
*/
proto.witbooking.backoffice.tag.v1.Tag.prototype.setAppliestoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.witbooking.backoffice.tag.v1.AppliesTo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.tag.v1.AppliesTo}
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.addAppliesto = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.witbooking.backoffice.tag.v1.AppliesTo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.tag.v1.Tag} returns this
 */
proto.witbooking.backoffice.tag.v1.Tag.prototype.clearAppliestoList = function() {
  return this.setAppliestoList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.Translation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.Translation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.Translation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.Translation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    translation: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.Translation}
 */
proto.witbooking.backoffice.tag.v1.Translation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.Translation;
  return proto.witbooking.backoffice.tag.v1.Translation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.Translation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.Translation}
 */
proto.witbooking.backoffice.tag.v1.Translation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTranslation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.Translation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.Translation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.Translation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.Translation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTranslation();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.tag.v1.Translation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.tag.v1.Translation} returns this
 */
proto.witbooking.backoffice.tag.v1.Translation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string translation = 2;
 * @return {string}
 */
proto.witbooking.backoffice.tag.v1.Translation.prototype.getTranslation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.tag.v1.Translation} returns this
 */
proto.witbooking.backoffice.tag.v1.Translation.prototype.setTranslation = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.AppliesTo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.AppliesTo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tickersList: jspb.Message.toObjectList(msg.getTickersList(),
    proto.witbooking.backoffice.tag.v1.TickerWithPosition.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.AppliesTo}
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.AppliesTo;
  return proto.witbooking.backoffice.tag.v1.AppliesTo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.AppliesTo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.AppliesTo}
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.witbooking.backoffice.tag.v1.AppliesToType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.tag.v1.TickerWithPosition;
      reader.readMessage(value,proto.witbooking.backoffice.tag.v1.TickerWithPosition.deserializeBinaryFromReader);
      msg.addTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.AppliesTo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.AppliesTo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTickersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.tag.v1.TickerWithPosition.serializeBinaryToWriter
    );
  }
};


/**
 * optional AppliesToType type = 1;
 * @return {!proto.witbooking.backoffice.tag.v1.AppliesToType}
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.prototype.getType = function() {
  return /** @type {!proto.witbooking.backoffice.tag.v1.AppliesToType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.witbooking.backoffice.tag.v1.AppliesToType} value
 * @return {!proto.witbooking.backoffice.tag.v1.AppliesTo} returns this
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated TickerWithPosition tickers = 2;
 * @return {!Array<!proto.witbooking.backoffice.tag.v1.TickerWithPosition>}
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.prototype.getTickersList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.tag.v1.TickerWithPosition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.tag.v1.TickerWithPosition, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.tag.v1.TickerWithPosition>} value
 * @return {!proto.witbooking.backoffice.tag.v1.AppliesTo} returns this
*/
proto.witbooking.backoffice.tag.v1.AppliesTo.prototype.setTickersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.tag.v1.TickerWithPosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.tag.v1.TickerWithPosition}
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.prototype.addTickers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.tag.v1.TickerWithPosition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.tag.v1.AppliesTo} returns this
 */
proto.witbooking.backoffice.tag.v1.AppliesTo.prototype.clearTickersList = function() {
  return this.setTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.tag.v1.TickerWithPosition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.tag.v1.TickerWithPosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    position: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.tag.v1.TickerWithPosition}
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.tag.v1.TickerWithPosition;
  return proto.witbooking.backoffice.tag.v1.TickerWithPosition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.tag.v1.TickerWithPosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.tag.v1.TickerWithPosition}
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.tag.v1.TickerWithPosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.tag.v1.TickerWithPosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.tag.v1.TickerWithPosition} returns this
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 position = 2;
 * @return {number}
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.tag.v1.TickerWithPosition} returns this
 */
proto.witbooking.backoffice.tag.v1.TickerWithPosition.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.tag.v1.AppliesToType = {
  PROPERTY: 0,
  ACCOMMODATION: 1,
  PACKAGE: 2,
  EXTRA: 3
};

goog.object.extend(exports, proto.witbooking.backoffice.tag.v1);
